import { FC, JSX } from "react";
import {
  Box,
  Button,
  Card,
  Container,
  Flex,
  Heading,
  Text,
} from "@radix-ui/themes";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Link } from "react-router-dom";
import MailIcon from "@/assets/email.svg?react";
import { useSendEmailVerification } from "@/features/auth/hooks/useSendEmailVerification";
import Alert from "@/components/Alert/Alert";

const VerifyAccountPage: FC = (): JSX.Element => {
  const user = useCurrentUserProfile((s) => s.user);
  // const [hasVerified, setHasVerified] = useState(false);

  const { loading, error, sendEmail, checkVerificationStatus } =
    useSendEmailVerification();

  return (
    <Box style={{ backgroundColor: "var(--accent-2)" }} minHeight="100vh">
      <Container size="2" px={{ initial: "4", lg: "0" }}>
        <Flex align="center" justify="center" height="100vh">
          <Card variant="surface" size={{ initial: "3", lg: "5" }}>
            <Flex direction="column" gap="5" align="center">
              <Flex justify="center">
                <MailIcon width={72} height={72} />
              </Flex>
              <Heading as="h1" size="5" m="0">
                Please verify your email
              </Heading>
              <Text as="p" align="center">
                You are almost there! We have sent an email to{" "}
                <Text weight="bold">{user.email}</Text>.
              </Text>
              <Text as="p" align="center">
                Just click the link in the email to verify your account. If you
                don't see the email, please{" "}
                <Text weight="bold">check your spam folder</Text>.
              </Text>
              {error && <Alert>{error.message}</Alert>}
              <Flex gap="3">
                <Button
                  variant="solid"
                  size="3"
                  onClick={checkVerificationStatus}
                  disabled={loading}
                >
                  {loading ? "Checkin your status" : "Continue"}
                </Button>
                <Button
                  variant="soft"
                  size="3"
                  onClick={sendEmail}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Resend email"}
                </Button>
              </Flex>
              <Text as="p" align="center">
                Need help? <Link to="/help">Contact us</Link>.
              </Text>
            </Flex>
          </Card>
        </Flex>
      </Container>
    </Box>
  );
};

export default VerifyAccountPage;
